/** Notification Types */
export const BAR_NOTIFICATION = 'bar'
export const MODAL_NOTIFICATION = 'modal'
